/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_3a2b57bb',
  textField: 'textField_3a2b57bb',
  eventWithLabel: 'eventWithLabel_3a2b57bb',
  eventWithoutLabel: 'eventWithoutLabel_3a2b57bb',
};

export = styles;

loadStyles([{"rawString":".root_3a2b57bb{box-sizing:border-box;box-shadow:none;margin:0;padding:0;margin-bottom:17px}.textField_3a2b57bb{position:relative}.textField_3a2b57bb input::-ms-clear{display:none}.textField_3a2b57bb input[readonly]{cursor:pointer}.eventWithLabel_3a2b57bb{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;bottom:5px}[dir=ltr] .eventWithLabel_3a2b57bb{right:9px}[dir=rtl] .eventWithLabel_3a2b57bb{left:9px}.eventWithoutLabel_3a2b57bb{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;top:7px}[dir=ltr] .eventWithoutLabel_3a2b57bb{right:9px}[dir=rtl] .eventWithoutLabel_3a2b57bb{left:9px}"}]);
/* tslint:enable */